import * as yup from 'yup';
import translation from 'i18n/translation.json';

export const useLoanConditionsSchema = () => {
  const schema = yup.object({
    principal: yup.string().required(() => {
      return translation.errors.requiredField;
    }),
    tenor: yup.string().required(() => {
      return translation.errors.requiredField;
    }),
    promoCode: yup.string(),
  });

  return { schema };
};
